import script from "./PyfProduct.vue?vue&type=script&setup=true&lang=js"
export * from "./PyfProduct.vue?vue&type=script&setup=true&lang=js"

import "./PyfProduct.vue?vue&type=style&index=0&id=065b432e&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-065b432e"]])

export default __exports__